module.exports = __webpack_public_path__ + "static/img/menu6_c2_1.d866c9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu6_c2_1.png
// module id = 0phn
// module chunks = 1